<template>
  <div class="app-container">
    <el-dialog
      title="修改剩余数量"
      :visible.sync="platNumModal"
      :close-on-click-modal="false"
      width="500px"
      center
      v-if="platNumModal"
    >
      <el-form ref="form" :model="form" label-width="100px">
        <div v-for="(item, index) in form.channelsList" :key="index">
          <el-form-item
            :label="item.name"
            :prop="'channelsList.' + index + '.residue_num'"
            :rules="{
              required: true,
              message: '请输入剩余数量',
              trigger: 'blur',
            }"
          >
            <el-input
              v-model.number="item.residue_num"
              style="width:300px;"
              clearable
              placeholder="请输入剩余数量"
            ></el-input>
          </el-form-item>
        </div>
        <div style="margin-left:82px;margin-top:40px;">
          <el-button @click="platNumModal = false">取消</el-button>
          <el-button
            type="primary"
            :loading="rejectSubmitting"
            @click="onReject('form')"
            >确认</el-button
          >
        </div>
      </el-form>
    </el-dialog>

    <div class="filter-head">
      <div class="filter-box">
        <div class="filter-item">
          <el-input
            v-model="listQuery.name"
            placeholder="产品/商家名称"
            clearable
          ></el-input>
        </div>
        <div class="filter-item">
          <el-select
            v-model="listQuery.type"
            placeholder="测评类型"
            clearable
            @change="onChangeType"
            @clear="onClearType"
          >
            <el-option label="产品体验" :value="1" />
            <el-option label="探店体验" :value="2" />
          </el-select>
        </div>
        <div class="filter-item">
          <el-select
            :loading="classifyLoading"
            v-model="listQuery.evaluation_class_id"
            placeholder="分类"
            clearable
            :disabled="!listQuery.type"
          >
            <el-option
              v-for="item in classifyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="filter-item">
          <el-select
            v-model="listQuery.commodity_type"
            placeholder="商品类型"
            clearable
          >
            <el-option label="测评类型" :value="1" />
            <el-option label="展示类型" :value="2" />
          </el-select>
        </div>
        <div class="filter-item">
          <el-select
            v-model="listQuery.recommend"
            placeholder="是否推荐"
            clearable
          >
            <el-option label="推荐" :value="1" />
            <el-option label="不推荐" :value="0" />
          </el-select>
        </div>

        <div class="filter-item">
          <el-select
            v-model="listQuery.is_merchant_activity"
            placeholder="是否商户活动"
            clearable
          >
            <el-option label="是" :value="1" />
            <el-option label="否" :value="0" />
          </el-select>
        </div>

        <div class="filter-item">
          <el-select v-model="listQuery.state" placeholder="上下架" clearable>
            <el-option label="正常" :value="1" />
            <el-option label="下架" :value="0" />
          </el-select>
        </div>
        <div class="filter-item">
          <el-select
            v-model="listQuery.activity_state"
            placeholder="活动状态"
            clearable
          >
            <el-option label="预告" :value="1" />
            <el-option label="招募中" :value="2" />
            <el-option label="进行中" :value="3" />
            <el-option label="已结束" :value="4" />
          </el-select>
        </div>
        <div
          class="filter-item"
          style="margin-right: 8px;white-space: nowrap;display: flex;align-items: center;"
        >
          招募时间
        </div>
        <el-date-picker
          class="filter-item"
          style="margin-right: 8px;"
          v-model="listQuery.date"
          @change="changedata"
          type="daterange"
          :default-time="['00:00:00', '23:59:59']"
          range-separator="至"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>

      <div class="filter-item">
        <el-button
          type="primary"
          style="margin-left:20px;"
          icon="el-icon-search"
          :loading="listLoading"
          @click="handleFilter"
          >查询
        </el-button>
      </div>
    </div>
    <div class="table">
      <div class="table-operations">
        <div>
          <el-button type="primary" icon="el-icon-plus" @click="handleAddTable">
            创建
          </el-button>
          <el-button
            type="warning"
            :loading="listLoading"
            icon="el-icon-upload2"
            @click="exportExcel"
            >导出Excel</el-button
          >
        </div>
      </div>

      <el-table
        v-loading="listLoading"
        element-loading-text="Loading"
        :data="tableData"
        border
        fit
        height="60vh"
        highlight-current-row
      >
        <el-table-column type="index" label="序号" width="95" align="center" />
        <el-table-column
          prop="poll"
          label="封面"
          min-width="125"
          align="center"
        >
          <template slot-scope="scope">
            <!-- <el-image style="width: 100px; height: 100px" :src="scope.row.cover_img_vertical" fit="cover" /> -->
            <img
              style="width:100px; height: 100px;object-fit: cover;"
              :src="scope.row.cover_img_vertical"
              alt="封面"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="产品名称"
          min-width="110"
          align="center"
        />
        <el-table-column
          prop="merchant_info.name"
          label="商家"
          min-width="110"
          align="center"
        />
        <el-table-column
          prop="type"
          label="测评类型"
          min-width="110"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 1">产品体验</el-tag>
            <el-tag v-else-if="scope.row.type === 2">探店体验</el-tag>
            <el-tag v-else>后端无字段</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="commodity_type"
          label="类型"
          min-width="110"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.commodity_type === 1">测评类型</el-tag>
            <el-tag v-else-if="scope.row.commodity_type === 2">展示类型</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="evaluation_class_info.name"
          label="分类"
          min-width="110"
          align="center"
        />
        <el-table-column
          prop="worth"
          label="价值"
          min-width="110"
          align="center"
        />
        <el-table-column
          prop="issues_num"
          label="数量"
          min-width="110"
          align="center"
        />
        <el-table-column label="剩余数量" min-width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.issues_num - scope.row.adopt_num }}
          </template>
        </el-table-column>
        <el-table-column
          prop="already_issues_num"
          label="申请人数"
          min-width="110"
          align="center"
        />

        <!-- <el-table-column label="推广平台(报名，剩余)" min-width="250" align="center">
                    <template slot-scope="scope">

                        <div style="display: flex;align-items:center;justify-content:center;flex-direction:column;">
                            <span v-for="item, index in scope.row.channelsDatas" :key="index">
                                <template v-if="item.state === 1">
                                    {{ item.name }} ({{ item.passers }},{{ item.issues_num - item.passers }})
                                </template>
                            </span>
                        </div>
                        <el-button type="primary" size="mini" style="margin-top:10px;"
                            :disabled="!scope.row.channelsDatas || scope.row.channelsDatas.filter(item => item.state).length === 0"
                            @click="updateResidueNum(scope.row)">修改剩余数量</el-button>

                    </template>
                </el-table-column> -->

        <el-table-column
          prop="is_merchant_activity"
          label="是否商户活动"
          min-width="110"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.is_merchant_activity === 1" type="success"
              >是</el-tag
            >
            <el-tag v-else type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="click_num"
          label="点击次数"
          min-width="110"
          align="center"
        />
        <el-table-column
          prop="click_people_num"
          label="点击人数"
          min-width="110"
          align="center"
        />
        <el-table-column
          prop="duration_avg"
          label="平均浏览时长"
          min-width="110"
          align="center"
        >
          <template slot-scope="scope">
            <div type="success">
              {{
                scope.row.duration_avg
                  ? parseInt(scope.row.duration_avg).toFixed(2)
                  : '0.00'
              }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="sort"
          label="权重"
          min-width="110"
          align="center"
        />
        <el-table-column
          prop="recommend"
          label="是否推荐"
          min-width="110"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.recommend === 1" type="success">是</el-tag>
            <el-tag v-else type="danger">否</el-tag>
          </template>
        </el-table-column>

        <el-table-column
          prop="activity_state"
          label="活动状态"
          min-width="110"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.activity_state === 1">预告</el-tag>
            <el-tag v-else-if="scope.row.activity_state === 2" type="warning"
              >招募中</el-tag
            >
            <el-tag v-else-if="scope.row.activity_state === 3" type="success"
              >进行中</el-tag
            >
            <el-tag v-else-if="scope.row.activity_state === 4" type="danger"
              >已结束</el-tag
            >
          </template>
        </el-table-column>

        <el-table-column
          prop="state"
          label="状态"
          min-width="110"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.state === 1" type="success">正常</el-tag>
            <el-tag v-else type="danger">已下架</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="260" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEditTable(scope.row)"
              >编辑</el-button
            >

            <el-button
              size="mini"
              type="primary"
              @click="
                setRecommendation(
                  scope.row,
                  scope.row.recommend ? '取消推荐' : '推荐'
                )
              "
              >{{ scope.row.recommend ? '取消推荐' : '设为推荐' }}</el-button
            >

            <el-button
              :type="scope.row.state ? 'warning' : 'success'"
              size="mini"
              @click="
                handleForbid(scope.row.id, scope.row.state ? '下架' : '上架')
              "
              >{{ scope.row.state ? '下架' : '上架' }}</el-button
            >

            <el-button
              type="danger"
              size="mini"
              style="margin-top: 10px;"
              v-if="scope.row.activity_state !== 4"
              @click="handleEnd(scope.row)"
              >结束活动</el-button
            >

            <el-button
              type="success"
              size="mini"
              style="margin-top: 10px;"
              v-if="scope.row.already_issues_num > 0"
              @click="exportApplyExcel(scope.row)"
              >导出报名资料</el-button
            >
            <el-button
              type="success"
              size="mini"
              style="margin-top: 10px;"
              v-if="
                (scope.row.order_type == 2 || scope.row.order_type == 3) &&
                  scope.row.already_issues_num > 0
              "
              @click="exportQuestion(scope.row)"
              >导出问卷</el-button
            >

            <!-- <el-popconfirm title="确定删除?" @confirm="handleDeleteTable(scope.row.id)"   @onConfirm="handleDeleteTable(scope.row.id)">
                            <el-button type="danger" slot="reference" size="mini" style="margin-left:10px;">删除
                            </el-button>
                        </el-popconfirm> -->
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          :current-page="listQuery.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="listQuery.limit"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <TableActionModal
      v-if="visible"
      :show.sync="visible"
      :type="modalType"
      :edit-data="editData"
      @onUpdate="onUpdated"
    />
  </div>
</template>

<script>
// 测评列表
import TableActionModal from './components/TableActionModal.vue'
import { review } from '@/api/review'
import * as XLSX from 'xlsx'
import { platformList, checkPlatform } from '@/utils/common'

export default {
  data: () => ({
    classifyLoading: false,
    classifyList: [],
    value: '',
    tableData: [],
    listLoading: false,
    total: null,
    listQuery: {
      page: 1,
      limit: 10,
      name: '',
      state: null,
      commodity_type: null,
      evaluation_class_id: null,
      recommend: null,
      type: null,
      activity_state: null,
      is_merchant_activity: null,
    },
    // 拟态
    visible: false,
    modalType: 'add',
    editData: null,
    form: {
      channelsList: [
        {
          name: '',
          residue_num: '',
        },
      ],
      id: '',
    },
    platNumModal: false,
    rejectSubmitting: false,
  }),
  components: {
    TableActionModal,
  },
  methods: {
    changedata(val) {
      console.log(val)
      if (val) {
        this.listQuery.start_at = val[0] + ' 00:00:00'
        this.listQuery.end_at = val[1] + ' 23:59:59'
      } else {
        this.listQuery.start_at = ''
        this.listQuery.end_at = ''
      }
    },
    // 多层嵌套无法输入解决方法
    change(e) {
      this.$forceUpdate()
    },
    updateResidueNum({ channelsDatas, id }) {
      this.form.channelsList = channelsDatas
        .filter((item) => item.state === 1)
        .map((item) => {
          return {
            name: item.name,
            residue_num: item.issues_num - item.passers,
            id: item.id,
          }
        })
      this.form.id = id
      this.platNumModal = true
    },
    onReject(formName) {
      let list = this.form.channelsList.map((item) => ({
        id: item.id,
        residue_num: item.residue_num,
      }))
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.rejectSubmitting = true
            await review.updateResidue({
              id: this.form.id,
              residue_array: list,
            })
            this.$message({
              message: '已修改!',
              type: 'success',
            })
            this.platNumModal = false
            await this.getList()
          } catch {
            this.$message.error('出错了!')
          } finally {
            this.rejectSubmitting = false
          }
        }
      })
    },
    async getList() {
      this.listLoading = true
      this.tableData = []
      const { data } = await review.list(this.listQuery)
      this.tableData = data.data
      this.tableData.channelsDatas
        ? (this.tableData.channelsDatas = this.tableData.channelsDatas
            .filter((item) => item.state === 1)
            .map((item) => {
              item.residue_num = ''
              return item
            }))
        : []

      this.total = data.total
      this.listLoading = false
    },
    async onChangeType(type) {
      this.listQuery.evaluation_class_id = null
      this.classifyLoading = true
      const { data } = await review.classify(type)
      this.classifyList = data
      this.classifyLoading = false
    },
    onClearType() {
      this.listQuery.evaluation_class_id = null
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    onUpdated() {
      this.getList()
    },
    handleAddTable() {
      this.setActiveModalType('add')
      this.visible = true
    },
    // 表格操作
    handleEditTable(data) {
      console.log('data;', data)
      this.editData = data
      this.setActiveModalType('edit')
      this.visible = true
    },
    setActiveModalType(type) {
      this.modalType = type
    },
    // 结束活动-
    handleEnd(scope) {
      this.$confirm('此操作将结束此活动, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        review.endActive({ id: scope.id }).then(() => {
          this.getList()
          this.$message({
            message: '操作成功!',
            type: 'success',
          })
        })
      })
    },
    handleForbid(id, text) {
      this.$confirm('此操作将' + text + '该测评, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        review.changeState(id).then(() => {
          this.getList()
          this.$message({
            message: '操作成功!',
            type: 'success',
          })
        })
      })
    },
    // handleDeleteTable(id) {
    //     review.delEvent(id).then(() => {
    //         this.getList()
    //         this.$message({
    //             message: '操作成功!',
    //             type: 'success'
    //         });
    //     })
    // },
    setRecommendation({ id, cover_img }, text) {
      if (text === '推荐' && !cover_img) {
        return this.$message.error('设为推荐需上传封面(横)')
      }

      this.$confirm('此操作将' + text + '该测评, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        review.setRecommendation(id).then(() => {
          this.getList()
          this.$message({
            message: '操作成功!',
            type: 'success',
          })
        })
      })
    },
    // 分页操作
    handleSizeChange(limit) {
      this.listQuery.limit = limit
      this.getList()
    },
    handleCurrentChange(page) {
      this.listQuery.page = page
      this.getList()
    },
    async exportQuestion(scope) {
      console.log('exportExcel')
      // +++修改excel-测评列表-导出问卷-附件2---ok
      const { total } = this
      if (!total) return

      try {
        // const { data: { data: { data: reqData }, moban: mobanData } } = await review.exportQuestionExcel({ id: 159 })
        const {
          data: {
            data: { data: reqData },
            moban: mobanData,
          },
        } = await review.exportQuestionExcel({ id: scope.id })
        console.log('reqData', reqData)
        console.log('mobanData', mobanData)
        // 问卷问题
        let mobanNameList = []

        // mobanData.template.forEach(mobanItem => {
        //     if (mobanItem.option.length > 1) {
        //         mobanNameList.push(mobanItem, ...mobanItem.option.map(item => ({ name: '', id: null, type: null })))
        //         mobanNameList.pop()
        //     } else {
        //         if (mobanItem.type == 4) {
        //             mmName = mobanItem
        //         } else {
        //             mobanNameList.push(mobanItem)
        //         }
        //     }
        // })
        // mmName ? mobanNameList.push(mmName) : ''
        let fujianList = []
        mobanData.template.forEach((mobanItem) => {
          if (mobanItem.type == 1 || mobanItem.type == 3) {
            //单选、名称
            mobanNameList.push(mobanItem)
          } else if (mobanItem.type == 2) {
            // 多选
            mobanNameList.push(
              mobanItem,
              ...mobanItem.option.map((item) => ({
                name: '',
                id: null,
                type: null,
              }))
            )
            mobanNameList.pop()
          } else if (mobanItem.type == 4) {
            // 链接（放最后）
            if (fujianList.length == 0) {
              mobanItem.name = '附件'
            } else {
              mobanItem.name = ''
            }
            fujianList.push(mobanItem)
          }
        })
        if (fujianList.length > 0) {
          mobanNameList.push(...fujianList)
        }
        console.log('mobanNameList', mobanNameList)

        // 重置推广数据
        reqData.forEach((reqDataItem) => {
          // 问卷答案
          reqDataItem.questionnaireList = []
          // 是否有答案
          if (reqDataItem.questionnaire_log) {
            let questionnaireObj = JSON.parse(reqDataItem.questionnaire_log)
            // 遍历模板
            mobanNameList.forEach((mobanItem, i) => {
              let flag = false // 问题是否有答案
              let questionnaireData = '' // 答案数据
              for (const key in questionnaireObj) {
                if (Object.hasOwnProperty.call(questionnaireObj, key)) {
                  const element = questionnaireObj[key]
                  if (!flag) {
                    if (mobanItem.id == key) {
                      questionnaireData = element
                      flag = true
                    } else {
                      flag = false
                    }
                  }
                }
              }
              // 判断是数组还是字符串
              if (Array.isArray(questionnaireData)) {
                if (questionnaireData[0] && questionnaireData[0].path) {
                  questionnaireData = questionnaireData.map((item) => item.path)
                }
              } else if (typeof questionnaireData === 'string') {
                questionnaireData = questionnaireData ? [questionnaireData] : []
              }
              console.log(questionnaireData, 'questionnaireData')
              if (flag && mobanItem.type == 2) {
                if (mobanItem.option.length - questionnaireData.length < 0) {
                  reqDataItem.questionnaireList.push(
                    ...questionnaireData.slice(0, mobanItem.option.length)
                  )
                } else {
                  reqDataItem.questionnaireList.push(
                    ...questionnaireData,
                    ...[
                      ...Array(
                        mobanItem.option.length - questionnaireData.length
                      ),
                    ].map((item) => '')
                  )
                }
              } else if (
                mobanItem.type == 1 ||
                mobanItem.type == 4 ||
                mobanItem.type == 3
              ) {
                reqDataItem.questionnaireList.push(...questionnaireData)
              }
            })
          } else {
            reqDataItem.questionnaireList.push(
              ...mobanNameList.map((item) => '')
            )
          }
        })
        var wb = XLSX.utils.book_new()
        var excelData = [
          ['', '', '', '', '', '', '', '问卷内容'],
          [
            'NO',
            'KOC名',
            '性別',
            '年龄',
            '居住地-国家',
            '居住地-省份',
            '问卷名称',
            ...mobanNameList.map((item) => item.name),
          ],
          ...reqData.map((item, index) => {
            if (item.user_info) {
              return [
                index + 1,
                item.user_info.name,
                item.user_info.gender === 1
                  ? '男性'
                  : item.user_info.gender === 2
                  ? '女性'
                  : '未设置',
                item.user_info.age_group === 1
                  ? '20岁以下'
                  : item.user_info.age_group === 2
                  ? '21~30岁'
                  : item.user_info.age_group === 3
                  ? '31~40岁'
                  : item.user_info.age_group === 4
                  ? '41~50岁'
                  : item.user_info.age_group === 5
                  ? '51岁以上'
                  : '未设置',
                item.user_info.country,
                item.user_info.provinces,
                mobanData.title,
                ...item.questionnaireList,
              ]
            } else {
              return []
            }
          }),
        ]

        console.log('excelData', excelData)

        // 找出最长数组
        let lengthNum = '',
          indexFlag = 1
        excelData.forEach((item, index) => {
          if (lengthNum < item.length) {
            lengthNum = item.length
            indexFlag = index
          }
        })
        // 转置 excelData 数组，将横向的表格转换为纵向
        var transposedData = excelData[indexFlag].map((col, i) =>
          excelData.map((row) => row[i])
        )

        var ws = XLSX.utils.aoa_to_sheet(transposedData)

        XLSX.utils.book_append_sheet(wb, ws, '问卷详情')
        XLSX.writeFile(wb, '测评列表-问卷详情.xlsx')

        this.$notify.info({
          title: '消息',
          message: '请等待, 正在生成Excel表格文件...',
        })
      } catch (e) {
        console.log(e)
        this.$notify.error({
          title: '错误',
          message: '获取数据错误!',
        })
      }
    },
    // 导出报名Excel
    async exportApplyExcel(scope) {
      console.log('exportExcel')
      // +++修改excel-测评列表-导出报名资料-附件1---ok
      // const { total } = this
      // if (!total) return

      try {
        const {
          data: { data: reqData },
        } = await review.exportReviewExcel({ id: scope.id })
        var wb = XLSX.utils.book_new()

        let platformNameList = [] // 一级标题
        let platformTypeList = [] // 二级标题
        let headerNum = 14 // 前面多少项

        platformList.forEach((item) => {
          platformNameList.push(...item.nameList)
          platformTypeList.push(...item.typeList)
        })

        // 前面14项空值
        for (let i = 0; i < headerNum; i++) {
          platformNameList.unshift('')
        }

        // 重置推广数据
        reqData.forEach((reqDataItem) => {
          // 渠道数据
          reqDataItem.channelsLists = []
          // 投稿平台
          reqDataItem.channelsTitle = ''
          // 探店日期
          reqDataItem.toStoreDate = ''

          // 有渠道列表
          if (reqDataItem.user_info.user_channel.length > 0) {
            // 遍历本地固定数据
            for (let i = 0; i < platformList.length; i++) {
              let platformItem = platformList[i]
              let flag = false
              let user_channelData = []
              // 遍历后台数据
              for (
                let dataIndex = 0;
                dataIndex < reqDataItem.user_info.user_channel.length;
                dataIndex++
              ) {
                const user_channelItem =
                  reqDataItem.user_info.user_channel[dataIndex]
                if (flag) continue
                // 如果该项有数据就填充数据，无数据就为空
                if (
                  user_channelItem.evaluation_channel_id === platformItem.id
                ) {
                  user_channelData = user_channelItem.data
                  let urlData = {} // 把第一个是链接的数据拿出来
                  let urlFlag = false // 判断第一个是不是链接

                  // 过滤不是链接的数据
                  user_channelData = user_channelItem.data.filter((item, i) => {
                    if (item.name === '链接' && i === 0) {
                      urlData = item
                      urlFlag = true
                      return false
                    } else {
                      return true
                    }
                  })

                  if (urlFlag) {
                    // 微博
                    if (user_channelItem.evaluation_channel_id === 3) {
                      user_channelData.splice(
                        user_channelData.length - 1,
                        0,
                        urlData
                      )
                    } else {
                      user_channelData.push(urlData)
                    }
                  }

                  // 微信朋友圈
                  if (user_channelItem.evaluation_channel_id === 4) {
                    user_channelData = user_channelItem.data
                      .filter((item) => item.name !== '名称')
                      .reverse()
                  }
                  flag = true
                } else {
                  flag = false
                }
              }
              // 通过flag判断有没有该平台的信息，有则赋值，没有则赋空值
              if (flag) {
                reqDataItem.channelsLists.push(
                  ...user_channelData.map((item) => item.content)
                )
              } else {
                reqDataItem.channelsLists.push(
                  ...platformItem.nameList.map((_) => '')
                )
              }
            }
          } else {
            // 没有渠道数据
            reqDataItem.channelsLists = platformTypeList.map(
              (platformTypeItem) => ''
            )
          }

          // 不是问卷
          if (reqDataItem.evaluation.order_type !== 2) {
            // reqDataItem.channelsTitle
            if (reqDataItem.channel_id) {
              // reqDataItem.channelsTitle = checkPlatform(reqDataItem.channel_id).name
              reqDataItem.channelsTitle = reqDataItem.channel_id
                .split(',')
                .map((item) => {
                  let platform = checkPlatform(item)
                  return platform.name
                })
                .join('+')
            } else {
              if (reqDataItem.evaluation.channels) {
                reqDataItem.channelsTitle = reqDataItem.evaluation.channels
                  .split(',')
                  .map((item) => {
                    let platform = checkPlatform(item)
                    return platform.name
                  })
                  .join('+')
              } else {
                reqDataItem.channelsTitle = ''
              }
            }

            // reqDataItem.toStoreDate
            if (
              reqDataItem.evaluation.type === 2 &&
              reqDataItem.to_store_at_datas &&
              reqDataItem.to_store_at_datas.length > 0
            ) {
              reqDataItem.toStoreDate = reqDataItem.to_store_at_datas.join('，')
            }
          }
        })

        var excelData = [
          platformNameList,
          [
            'NO',
            'KOC名',
            '性別',
            '年龄',
            '手机号',
            '居住地-国家',
            '居住地-省份',
            '微信ID',
            '邮箱',
            '擅长领域',
            '投稿平台',
            '测评类型',
            '体验商品/体验方案',
            '探店日期',
            ...platformTypeList,
          ],
          ...reqData.map((item, index) => [
            index + 1,
            item.user_info.name,
            item.user_info.gender === 1
              ? '男性'
              : item.user_info.gender === 2
              ? '女性'
              : '未设置',
            item.user_info.age_group === 1
              ? '20岁以下'
              : item.user_info.age_group === 2
              ? '21~30岁'
              : item.user_info.age_group === 3
              ? '31~40岁'
              : item.user_info.age_group === 4
              ? '41~50岁'
              : item.user_info.age_group === 5
              ? '51岁以上'
              : '未设置',
            item.user_info.account,
            item.user_info.country,
            item.user_info.provinces,
            item.user_info.wx_id,
            item.user_info.email,
            item.user_info.evaluation_type_field.length > 0
              ? item.user_info.evaluation_type_field
                  .map((item) => item.name)
                  .join(',')
              : '',
            item.channelsTitle,
            item.evaluation.type === 1 ? '产品测评' : '探店测评',
            item.evaluation.name,
            item.toStoreDate,
            ...item.channelsLists,
          ]),
        ]
        var ws = XLSX.utils.aoa_to_sheet(excelData)

        // 定义合并的范围
        const mergeCells = platformList.map((item) => {
          let obj = {
            s: { r: 0, c: headerNum },
            e: { r: 0, c: headerNum + item.nameList.length - 1 },
          } //索引从0开始
          headerNum = headerNum + item.nameList.length
          return obj
        })

        // 设置合并的单元格
        ws['!merges'] = mergeCells

        XLSX.utils.book_append_sheet(wb, ws, '用户详情')
        XLSX.writeFile(wb, '测评列表-体验申请-用户详情.xlsx')

        this.$notify.info({
          title: '消息',
          message: '请等待, 正在生成Excel表格文件...',
        })
      } catch {
        this.$notify.error({
          title: '错误',
          message: '获取数据错误!',
        })
      }
    },
    // 导出Excel
    async exportExcel() {
      console.log('exportExcel')

      const { total } = this
      if (!total) return

      try {
        const {
          data: { data: reqData },
        } = await review.list({
          ...this.listQuery,
          page: 1,
          limit: 99999999999,
        })
        console.log(reqData)

        var wb = XLSX.utils.book_new()

        var excelData = [
          [
            '产品名称',
            '商家',
            '测评类型',
            '类型',
            '分类',
            '价值',
            '数量',
            '剩余数量',
            '申请人数',
            '点击次数',
            '点击人数',
            '平均浏览时长',
            '权重',
            '是否推荐',
            '活动状态',
            '状态',
          ],
          ...reqData.map((item) => [
            item.name,
            item.merchant_info.name,
            item.type === 1
              ? '产品体验'
              : item.type === 2
              ? '探店体验'
              : '无字段',
            item.commodity_type === 1 ? '测评类型' : '展示类型',
            item.evaluation_class_info.name,
            item.worth,
            item.issues_num,
            item.issues_num - item.adopt_num,
            item.already_issues_num,
            item.click_num,
            item.click_people_num,
            item.duration_avg,
            item.sort,
            item.recommend ? '是' : '否',
            item.activity_state === 1
              ? '预告'
              : item.activity_state === 2
              ? '招募中'
              : item.activity_state === 3
              ? '进行中'
              : item.activity_state === 4
              ? '已结束'
              : '无字段',
            item.state ? '正常' : '冻结',
          ]),
        ]
        var ws = XLSX.utils.aoa_to_sheet(excelData)
        XLSX.utils.book_append_sheet(wb, ws, '测评列表')
        XLSX.writeFile(wb, '测评列表.xlsx')

        this.$notify.info({
          title: '消息',
          message: '请等待, 正在生成Excel表格文件...',
        })
      } catch {
        this.$notify.error({
          title: '错误',
          message: '获取数据错误!',
        })
      }
    },
  },
  created() {
    this.getList()
  },
}
</script>

<style lang="scss" scoped>
.filter-head {
  display: flex;
  // justify-content: space-between;
  flex-wrap: nowrap;

  .filter-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    margin: -5px -10px;

    & > .filter-item {
      margin: 5px 10px;
    }
  }
}

.table {
  margin-top: 20px;

  .table-operations {
    min-width: 500px;
    max-width: 70%;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    // justify-content: space-between;
  }
}
</style>
